import {
  MoreOutlined
} from '@ant-design/icons';
import { IFeed } from '@interfaces/feed';
import {
  Divider, Dropdown, MenuProps,
  message
} from 'antd';
import Link from 'next/link';
import { useSelector } from 'react-redux';

import { copyToClipboard, showError } from '@lib/utils';
import { feedService } from '@services/feed.service';
import { useRouter } from 'next/router';
import style from './dropdown-actions.module.scss';

type Props = {
  feed: IFeed;
};

function DropdownActions({
  feed
}: Props) {
  const user = useSelector((state: any) => state.user.current);
  const router = useRouter();

  const items: MenuProps['items'] = [
    {
      key: `copy_link_${feed._id}`,
      label: (
        <a
          aria-hidden
          onClick={() => {
            copyToClipboard(`${window.location.origin}/post/${feed.slug}`);
          }}
        >
          Copy link
        </a>
      )
    }
  ];
  if (user?._id === feed.fromSourceId) {
    items.push(...[
      {
        key: 'divider',
        label: <Divider style={{ margin: '10px 0' }} />
      },
      {
        key: `delete_${feed._id}`,
        label: (
          <a
            aria-hidden
            onClick={async () => {
              try {
                await feedService.delete(feed._id);
                message.success('Post was deleted');
                router.reload();
              } catch (e) {
                showError(e);
              }
            }}
          >
            Delete post
          </a>
        )
      },
      {
        key: `edit_${feed._id}`,
        label: (
          <Link
            href={`/creator/my-post/edit/${feed._id}`}
          >
            Edit post
          </Link>
        )
      }
    ]);
  }

  return (
    <Dropdown menu={{ items }} className={style['dropdown-options']}>
      <MoreOutlined />
    </Dropdown>
  );
}

export default DropdownActions;
